
import { computed, defineComponent, reactive } from "vue";
import { userService } from "@/service";
import { useRoute } from "vue-router";
import { useStore } from "@/store";
export default defineComponent({
  setup() {
    const route = useRoute();
    const store = useStore();
    const userInfo = computed(() => store.state.userInfo);
    const storeInfo = reactive<any>({
      data: null,
      async getUserInfo() {
        const { data } = await userService.userInfo({
          user_id: route.query.userId,
          user_information: 1
        });
        storeInfo.data = data.data;
      }
    });
    const firstName = computed(() => {
      return storeInfo.data.name?.split("")[0];
    });
    storeInfo.getUserInfo();
    return {
      storeInfo,
      userInfo,
      firstName
    };
  }
});
